//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { ProdutosContext } from "../context/ProdutosContext";
import { loadProductsService, disableProductService } from "../services";



//--------------- EXPORTAÇÃO DO COMPONENTE TABELA DE PRODUTOS ---------------//
export default function TableProducts() {



    //--------------- CRIAÇÃO DOS HOOKS ---------------//
    const { products, setProducts } = useContext(ProdutosContext); // Estado que armazena a lista de Produtos existentes
    const { formDataModalEditProduct, setFormDataModalEditProduct } = useContext(ProdutosContext); // Estado que armazena o Objeto Formulário
    const { isOpenModalEditProduct, setIsOpenModalEditProduct } = useContext(ProdutosContext); // Estado que armazena se o Modal de criação de Produto está aberto ou não



    //--------------- FUNÇÃO ASSÍNCRONA CARREGAR PRODUTOS ---------------//
    // Responsável por requisitar à API os produtos existentes
    // Armazena no Estado "produtos" a lista de produtos retornadas pela API
    async function handleRefreshProducts() {
        const response = await loadProductsService();
        if (response) {
            setProducts(response.data);
        }
    };



    //--------------- FUNÇÃO ABRIR MODAL ---------------//
    // Responsável por abrir o Modal de Editar ou Criar Produto
    function handleOpenModalEditProduct(product) {
        setFormDataModalEditProduct({
            id: product.id,
            nome: product.nome || "",
            id_produto_hotmart: product.id_produto_hotmart || "",
            id_produto_kiwify: product.id_produto_kiwify || "",
            id_produto_lastlink: product.id_produto_lastlink || "",
            descricao: product.descricao || "",
            conhecimento_extra: product.conhecimento_extra || "",
        });
        setIsOpenModalEditProduct(true);
    };



    //--------------- FUNÇÃO ASSÍNCRONA INATIVAR PRODUTO ---------------//
    // Responsável por inativar o Produto selecionado via API
    const handleDisableProduct = async (id) => {
        const response = await disableProductService(id);
        if (response) {
            handleRefreshProducts();
        }
    };



    //--------------- RETORNO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
    return (
        <>

            {/* DIV QUE CONTÊM A TABELA */}
            <div className="bg-surface-2 rounded-xl overflow-hidden shadow border border-white/[0.08]">


                {/* TABELA */}
                <table className="w-full text-xs sm:text-sm table-fixed">

                    {/* CABEÇALHO DA TABELA */}
                    <thead className="bg-surface-3">
                        <tr>
                            <th className="p-3 text-left w-[20%] sm:w-[20%] truncate">Nome</th>
                            <th className="p-3 text-left w-[40%] sm:w-[20%] truncate">ID Hotmart</th>
                            <th className="p-3 text-left w-[40%] sm:w-[20%] truncate">ID Kiwify</th>
                            <th className="p-3 text-left w-[40%] sm:w-[20%] truncate">ID Lastlink</th>
                            <th className="p-3 text-left sm:w-[40%] hidden sm:table-cell truncate">Ações</th>
                        </tr>
                    </thead>


                    {/* CORPO DA TABELA */}
                    <tbody>
                        {products.map((product) => (
                            <>

                                {/* LINHA QUE APARECE INDEPENDENTE DA LARGURA DA TELA */}
                                <tr key={product.id} className="sm:border-b sm:border-white/[0.08]">


                                    {/* CÉLULA DO NOME DO PRODUTO */}
                                    <td className="p-3 w-[20%] sm:w-[30%]">{product.nome}</td>
                                    {/* CÉLULA DO ID DO PRODUTO HOTMART */}
                                    <td className="p-3 w-[40%] sm:w-[20%] truncate">{product.id_produto_hotmart}</td>
                                    {/* CÉLULA DO ID DO PRODUTO KIWIFY */}
                                    <td className="p-3 w-[40%] sm:w-[20%] truncate">{product.id_produto_kiwify}</td>
                                    {/* CÉLULA DO ID DO PRODUTO LASTLINK */}
                                    <td className="p-3 w-[40%] sm:w-[20%] truncate" title={product.id_produto_lastlink || ""}>{product.id_produto_lastlink}</td>


                                    {/* CÉLULA COM OS BUTTONS DAS AÇÕES SÓ APARECE QUANDO A LARGURA DA TELA É SUPERIOR A 640px  */}
                                    <td className="p-3 sm:w-[40%] hidden sm:table-cell truncate">
                                        <div className="flex gap-2 flex-col sm:flex-row">

                                            {/* BUTTON EDITAR PRODUTO */}
                                            <button
                                                onClick={() => handleOpenModalEditProduct(product)}
                                                className="bg-blue-600 hover:bg-blue-700 px-2 py-1 rounded"
                                            >
                                                Editar
                                            </button>

                                            {/* BUTTON INATIVAR PRODUTO */}
                                            <button
                                                onClick={() => handleDisableProduct(product.id)}
                                                className="bg-red-600 hover:bg-red-700 px-2 py-1 rounded"
                                            >
                                                Inativar
                                            </button>
                                        </div>
                                    </td>

                                </tr>


                                {/* LINHA QUE APARECE SOMENTE QUANDO A LARGURA DA TELA É INFERIOR A 640px  */}
                                <tr className="sm:hidden border-b border-white/[0.08]">
                                    <td colSpan={2} >
                                        <div className="flex flex-row gap-2 items-center text-right p-3">

                                            {/* BUTTON EDITAR PRODUTO */}
                                            <button
                                                onClick={() => handleOpenModalEditProduct(product)}
                                                className="ml-auto block bg-blue-600 hover:bg-blue-700 px-2 py-1 rounded"
                                            >
                                                Editar
                                            </button>

                                            {/* BUTTON INATIVAR PRODUTO */}
                                            <button
                                                onClick={() => handleDisableProduct(product.id)}
                                                className="block bg-red-600 hover:bg-red-700 px-2 py-1 rounded"
                                            >
                                                Inativar
                                            </button>

                                        </div>
                                    </td>
                                </tr>


                            </>
                        ))}
                        {products.length === 0 &&
                            <tr>
                                <td colSpan={3} className="p-3 text-center">Nenhum produto cadastrado.</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>

        </>
    )
}